/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/21/14
 * Time: 5:05 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";
    var LE = require("app");
    var CP_CONST = require("connection-const");
    var Storage = require("assets/js/storage");
    var SnippetModel = require("connection-models/KPsTab/SnippetModel");
    var LEConfig = require("assets/config/le-env-conf");
    var CourierManager = require("connection-controllers/parentManagers/CourierManager");
    var CONST = require("const");
    var Privileges = require("codeTables/privileges.json");

    var LiveEngageManager = {};
    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {
        LiveEngageManager = Marionette.Controller.extend({
            DEFAULT_SETTINGS: {
                IS_OPEN: false,
                SELECTED_TAB: CP_CONST.TABS.CONTENT,
                SELECTED_KP: null,
                LOCALE: "en-US"
            },
            ACTIVITY: {
                OPEN_DATA_BAR: "openDataBar",
                OPEN_PERSONALIZATION: "openPersonalization",
                MODULE_ACTIVITY: "moduleActivity"
            },
            _currentActivities: {
                openDataBar: false,
                openPersonalization: false,
                moduleActivity: null
            },
            moduleActivityEvent: null,

            currentActivities: {},
            LOCAL_STORAGE_PREFIX: "connectionPanel_",

            start: function (connectionPanelContextModel) {
                this.connectionPanelContextModel = connectionPanelContextModel;
                this._handleLocalStorage();
                this._setContextListeners();
                this._setParentRequestsListeners();
                this._setContextModelListeners();
                this._setCurrentContext();
                this._setSubManagers();
            },

            getVisibility: function () {
                var isAuthenticated = LE.sessionManager.isAuthenticated();
                var permissionGroup = LE.sessionManager.getPermissionGroupByPrivilege(); //may return null

                var isArticleVisible = !isAuthenticated,
                    isChatVisible = !isAuthenticated,
                    isCaseVisible = false,
                    isCreateCaseVisible = false,
                    isNotificationVisible = false;

                var isCPVisibleAC = LE.sessionManager.hasConnectionBarDisplay(),
                    isOpenCaseVisibleAC = LE.sessionManager.hasConnectionBarOpenCaseVisible() || false,
                    isCasesVisibleAC = LE.sessionManager.hasConnectionBarCaseManagementVisible() || false,
                    isNotificationVisibleAC = LE.sessionManager.hasConnectionBarNotificationVisible() || false;

                if (isCPVisibleAC === true) { //AC features trump permissions
                    if (LE.sessionManager.hasProfilesFeature()) {
                        isCaseVisible = this._hasViewCasePrivileges();
                        isCreateCaseVisible = isOpenCaseVisibleAC && this._hasOpenCasePrivileges();
                        isArticleVisible = this._hasViewContentPrivileges();
                        isChatVisible = this._hasChatWithSupportPrivileges();
                        isNotificationVisible =  isNotificationVisibleAC && this._hasViewNotificationPrivileges();
                    } else {
                        var visibilityChatArticle = this._getConnectionPanelVisibility(permissionGroup);
                        isArticleVisible = visibilityChatArticle.isArticleVisible;
                        isChatVisible = visibilityChatArticle.isChatVisible;
                        isCaseVisible = isCasesVisibleAC && this._getVisibilityForPermissionGroup(LE.siteSettings.connectionPanelVisibilitySettings.getViewCaseVisibility(), permissionGroup);
                        isCreateCaseVisible = isOpenCaseVisibleAC && this._getVisibilityForPermissionGroup(LE.siteSettings.connectionPanelVisibilitySettings.getOpenCaseVisibility(), permissionGroup);
                    }
                }

                var visibilityCP = {};
                visibilityCP[CP_CONST.VISIBILITY.KP] = isArticleVisible;
                visibilityCP[CP_CONST.VISIBILITY.CHAT] = isChatVisible;
                visibilityCP[CP_CONST.VISIBILITY.CASES] = isCaseVisible;
                visibilityCP[CP_CONST.VISIBILITY.CREATE_CASE] = isCreateCaseVisible;
                visibilityCP[CP_CONST.VISIBILITY.NOTIFICATION_CENTER] = isNotificationVisible;

                return visibilityCP;
            },

            _getVisibilityForPermissionGroup: function (currentVisibility, permissionGroup) {
                var isVisible = false;
                switch(currentVisibility) {
                    case CP_CONST.CASES_VISIBILITY.ALL:
                        isVisible = true;
                        break;
                    case CP_CONST.CASES_VISIBILITY.ALL_BUT_AGENT:
                        if (permissionGroup !== CONST.PERMISSION_GROUP.AGENT) {
                            isVisible = true;
                        }
                        break;
                    case CP_CONST.CASES_VISIBILITY.ADMIN:
                        if (permissionGroup === CONST.PERMISSION_GROUP.ADMIN) {
                            isVisible = true;
                        }
                        break;
                    case CP_CONST.CASES_VISIBILITY.NONE:
                        break;
                }
                return isVisible;
            },

            _getConnectionPanelVisibility: function(permissionGroup){
                var isArticleVisible = false,
                    isChatVisible = false;

                switch(LE.siteSettings.connectionPanelVisibilitySettings.getCurrentVisibility()){
                    case CP_CONST.CP_VISIBILITY.ALL:
                        isArticleVisible = isChatVisible = true;
                        break;
                    case CP_CONST.CP_VISIBILITY.CHAT_NOT_AGENTS:
                        isArticleVisible = true;
                        if(permissionGroup !== CONST.PERMISSION_GROUP.AGENT){
                            isChatVisible = true;
                        }
                        break;
                    case CP_CONST.CP_VISIBILITY.ARTICLES:
                        if(permissionGroup === CONST.PERMISSION_GROUP.CAMPAIGN_MANAGER || permissionGroup === CONST.PERMISSION_GROUP.AGENT_MANAGER){
                            isArticleVisible = true;
                        }
                        if(permissionGroup === CONST.PERMISSION_GROUP.ADMIN){
                            isArticleVisible = isChatVisible = true;
                        }
                        break;
                    case CP_CONST.CP_VISIBILITY.ADMIN_ONLY:
                        if(permissionGroup === CONST.PERMISSION_GROUP.ADMIN){
                            isArticleVisible = isChatVisible = true;
                        }
                        break;
                    case CP_CONST.CP_VISIBILITY.NONE:
                        break;
                    case CP_CONST.CP_VISIBILITY.ALL_BUT_AGENTS:
                        if(permissionGroup !== CONST.PERMISSION_GROUP.AGENT){
                            isArticleVisible = isChatVisible = true;
                        }
                        break;
                    default:
                        isArticleVisible = isChatVisible = true;
                }
                return {
                    isArticleVisible: isArticleVisible,
                    isChatVisible: isChatVisible
                };
            },

            _hasViewCasePrivileges: function (){
                if (LE && LE.sessionManager && LE.sessionManager.hasPrivilege) {
                    if (LE.sessionManager.hasPrivilege(Privileges.privilegeIDs.VIEW_SUPPORT_CASES)) {
                        return true;
                    }
                }
                return false;
            },

            _hasOpenCasePrivileges: function(){
                if (LE && LE.sessionManager && LE.sessionManager.hasPrivilege) {
                    if (LE.sessionManager.hasPrivilege(Privileges.privilegeIDs.OPEN_SUPPORT_CASE)) {
                        return true;
                    }
                }
                return false;
            },

            _hasChatWithSupportPrivileges: function(){
                if (LE && LE.sessionManager && LE.sessionManager.hasPrivilege) {
                    if (LE.sessionManager.hasPrivilege(Privileges.privilegeIDs.CHAT_WITH_SUPPORT)) {
                        return true;
                    }
                }
                return false;
            },

            _hasViewContentPrivileges: function(){
                if (LE && LE.sessionManager && LE.sessionManager.hasPrivilege) {
                    if (LE.sessionManager.hasPrivilege(Privileges.privilegeIDs.VIEW_CONNECTION_CONTENT)) {
                        return true;
                    }
                }
                return false;
            },

            _hasViewNotificationPrivileges: function (){
                if (LE && LE.sessionManager && LE.sessionManager.hasPrivilege) {
                    var hasAccountLevelNotifications = LE.sessionManager.hasPrivilege(Privileges.privilegeIDs.VIEW_ACCOUNT_LEVEL_NOTIFICATIONS);
                    var hasUserLevelNotifications = LE.sessionManager.hasPrivilege(Privileges.privilegeIDs.VIEW_USER_LEVEL_NOTIFICATIONS);
                    if (hasAccountLevelNotifications || hasUserLevelNotifications) {
                        return true;
                    }
                }
                return false;
            },

            saveInLocalStorage: function(key,value){
                this._setStoragePropertyByKey(key,value);
            },

            getFromLocalStorage: function(key){
                return this._getStoragePropertyByKey(key);
            },


            _setSubManagers: function () {
                this.courierManager = new CourierManager({
                    connectionPanelContextModel: this.connectionPanelContextModel
                });

            },
            getCurrentContext: function () {
                return this._currentContex;
            },
            onLeave: function () {
                this._setStoragePropertyByKey("logOutTime", (new Date()).getTime());
                //this._cleanLocalStorage();
            },
            _setCurrentContext: function () {
                var activeModuleName = LE.context.get("activeModuleName");
                this._currentContex = {
                    context: {
                        area: activeModuleName,
                        page: this._getPageNameByRoute(LE.context.get("navigationCurrent.route")),
                        activities: this._getCurrentActivities(activeModuleName)
                    },
                    userId: this._getUserId(),
                    accountId: this._getAccountId(),
                    locale: this._getLocale(),
                    isSoundEnabled: LE.soundController.isEnabled(),
                    persona: LE.sessionManager.getActivePersona()
                };
                var currentKP = this._getCurrentKP();
                this._currentContex.selectedKP = currentKP.selectedKP;
                this._currentContex.referrerAction = currentKP.referrerAction;
                this._currentContex.selectedTab = this._getSelectedTab();
                this._currentContex.isOpen = this._getIsOpen(this._currentContex.selectedKP);
            },

            _getIsOpen: function (selectedKP) {
                return (selectedKP || this._isAutoOpenCP());
            },
            _getSelectedTab: function () {
                var selectedTab = this._getStoragePropertyByKey("selectedTab");
                if (_.isEmpty(selectedTab)) {
                    if (!LE.sessionManager.isAuthenticated()) {
                        selectedTab = CP_CONST.TABS.CHAT;
                    }
                }
                return selectedTab;
            },
            _getCurrentKP: function () {
                var currentKP = {};

                var slug = this._getCurrentSlugByQueryString();
                if (slug) {
                    currentKP.referrerAction = CP_CONST.REFERER_ACTION.DIRECT_LINK_TO_CONTENT;
                    currentKP.selectedKP = this._getCurrentSnippetModel(slug);
                }
                else {
                    slug = this._getCurrentSlugFromLocalStorage();
                    if (slug) {
                        currentKP.referrerAction = CP_CONST.REFERER_ACTION.REFRESH;
                        currentKP.selectedKP = this._getCurrentSnippetModel(slug);
                    }
                }
                return currentKP;
            },
            _getCurrentSlugFromLocalStorage: function () {
                var slug = this._getStoragePropertyByKey("slug");
                if (!slug || slug === "null" || slug === "undefined") {
                    slug = this.DEFAULT_SETTINGS.SELECTED_KP;
                }
                return slug;
            },
            _getCurrentSlugByQueryString: function () {
                var slug = LE.getQueryStringParameterValue(CP_CONST.DIRECT_LINKS.ARTICLE);
                if (slug) {
                    LE.navigator.removeFragment({replace: true, removeQueryParams: [CP_CONST.DIRECT_LINKS.ARTICLE]});
                }
                return slug;
            },
            _getCurrentSnippetModel: function (slug) {
                return new SnippetModel({
                    slug: slug,
                    lang: this._getLocale(),
                    isFetched: false
                });
            },
            _setContextListeners: function () {
                this.activeModuleName = "";

                this.listenTo(LE.context, "change:navigationCurrent.fixedRoute", function (model, fixedRoute) {
                    var noUserId= !this.connectionPanelContextModel.get("userId");
                    var isLargeCPThumb= fixedRoute === "registration!changePlanSelection" || noUserId;
                    this.connectionPanelContextModel.set("context.largeThumb", isLargeCPThumb);

                    var activeModuleName = LE.navigator.getActiveRouter().routerModule;
                    if (this.activeModuleName !== activeModuleName) {
                        this.connectionPanelContextModel.set("context.area", activeModuleName);
                        this._setActivityEventListener(activeModuleName);
                        this.activeModuleName = activeModuleName;
                    }
                    if (activeModuleName === "LEWebAgent") {
                        this.connectionPanelContextModel.set("context.page", LE.context.get("LEWebAgent.page"));
                    }
                    else {
                        var route = this._getRouteBuyFixedRout(fixedRoute);
                        var page = this._getPageNameByRoute(route);
                        this.connectionPanelContextModel.set("context.page", page);
                    }
                });

                this.listenTo(LE.context, "change:LEWebAgent.page", function (model, page) {
                    var activeModuleName = LE.navigator.getActiveRouter().routerModule;
                    if (activeModuleName === "LEWebAgent") {
                        this.connectionPanelContextModel.set("context.page", page);
                    }
                });

                this.listenTo(LE.context, "change:LEReporting.isOpened", function (model, isOpened) {
                    this._setActivity(this.ACTIVITY.OPEN_DATA_BAR, isOpened);
                });
                this.listenTo(LE.context, "change:LEPersonalization.isOpened", function (model, isOpened) {
                    this._setActivity(this.ACTIVITY.OPEN_PERSONALIZATION, isOpened);
                });

                this.listenTo(LE.soundController, "change", this._onSoundStateChange);
                this.listenTo(LEConnection.vent, "cp:clearLocalStorage", this._cleanLocalStorage);
            },

            _getPageNameByRoute: function (route) {
                var pageName;
                var activeRouter = LE.navigator.getActiveRouter();
                if (activeRouter && activeRouter.controller.getActivePageName) {
                    pageName = activeRouter.controller.getActivePageName(route);
                }
                return pageName;
            },

            _setActivityEventListener: function (activeModuleName) {
                //get current activity
                this._setActivity(this.ACTIVITY.MODULE_ACTIVITY, LE.context.get(activeModuleName + ".activity"));

                //listen to activity changes on current active module
                //1.stop listening to the previous event
                if (this.moduleActivityEvent) {
                    this.stopListening(LE.context, this.moduleActivityEvent);
                }
                //2. start listening to the new event
                this.moduleActivityEvent = "change:" + activeModuleName + ".activity";
                this.listenTo(LE.context, this.moduleActivityEvent, function (model, activity) {
                    this.moduleActivity = activity;
                    this._setActivity(this.ACTIVITY.MODULE_ACTIVITY, activity);
                });

            },

            _setActivity: function (activity, state) {
                this._currentActivities[activity] = state;
                this.connectionPanelContextModel.set("context.activities", this._getActivitiesArr());
            },
            _getCurrentActivities: function (activeModuleName) {
                this._currentActivities.openDataBar = LE.context.get("LEReporting:isOpened");
                this._currentActivities.openPersonalization = LE.context.get("LEPersonalization:isOpened");
                this._currentActivities.moduleActivity = LE.context.get(activeModuleName + ".activity");
                return this._getActivitiesArr();
            },
            _getActivitiesArr: function () {
                var activitiesArr = [];
                if (this._currentActivities.moduleActivity) {
                    activitiesArr.push(this.moduleActivity);
                }
                if (this._currentActivities.openDataBar) {
                    activitiesArr.push("openDataBar");
                }
                if (this._currentActivities.openPersonalization) {
                    activitiesArr.push("openPersonalization");
                }
                return activitiesArr;
            },
            _getUserId: function () {
                return LE.sessionManager.getUserId();
            },
            _getAccountId: function () {
                return LE.sessionManager.getAccountId() || null;
            },
            _getLocale: function () {
                var locale;
                if (LE.siteSettings) {
                    locale = LE.siteSettings.languageSettings.getAccountLocale();
                }
                else {
                    locale = LE.localeResolver.getLocale();
                }
                if (!locale) {
                    locale = this.DEFAULT_SETTINGS.LOCALE;
                }
                return locale;
            },
            _setParentRequestsListeners: function () {
                LEConnection.channel.comply(LE.mediaCodes.connection.commands.openConnectionPanel, this._openConnectionPanel, this);
                LEConnection.channel.comply(LE.mediaCodes.connection.commands.closeConnectionPanel, this._closeConnectionPanel, this);
                LEConnection.channel.comply(LE.mediaCodes.connection.commands.openConnectionPanelChatTab, this._openConnectionPanelChatTab, this);
                LEConnection.channel.comply(LE.mediaCodes.connection.commands.openConnectionPanelContentTab, this._openConnectionPanelContentTab, this);
                LEConnection.channel.comply(LE.mediaCodes.connection.commands.showArticle, this._showArticle, this);
                LEConnection.channel.comply(LE.mediaCodes.connection.commands.startChatWithGroup, this._startChatWithGroup, this);
                LEConnection.channel.comply(LE.mediaCodes.connection.commands.setContext, this._setContextFromExternal, this);

                LEConnection.vent.on("article:close",this._removeSlugFromStorage,this);
                LEConnection.vent.on("ConnectionPanelLayoutController:closeConnectionPanel",this._closeConnectionPanel,this);
                //will be deprecated on 1.4.2015
                LE.vent.on("openKP", this._showArticleOldCP, this);
            },
            _openConnectionPanel: function () {
                this.connectionPanelContextModel.set("isOpen", true);
            },
            _closeConnectionPanel: function () {
                this.connectionPanelContextModel.set({isOpen: false, selectedKP: null, referrerAction: null});
                this._removeSlugFromStorage();
            },
            _removeSlugFromStorage: function () {
                this._setStoragePropertyByKey("slug", null);
            },
            _openConnectionPanelChatTab: function () {
                this.connectionPanelContextModel.set({
                    "selectedTab": CP_CONST.TABS.CHAT,
                    "isOpen": true
                });
            },
            _openConnectionPanelContentTab: function () {
                this.connectionPanelContextModel.set({
                    "selectedTab": CP_CONST.TABS.CONTENT,
                    "isOpen": true
                });
            },
            _showArticle: function (slug) {
                if (!slug) {
                    LEConnection.logger.error("LiveEngageManager:_showArticle - must provide slug");
                    LEConnection.logger.graph({name:"connection:LiveEngageManager:_showArticle:missingSlug"});
                }
                else {
                    this.connectionPanelContextModel.set({
                        "selectedTab": CP_CONST.TABS.CONTENT,
                        "isOpen": true
                    });
                    LEConnection.vent.trigger("Article:requested", {
                        slug: slug,
                        referrerAction: CP_CONST.REFERER_ACTION.CLICK_TO_CONTENT
                    });
                }

            },
            _startChatWithGroup: function (data) {
                this.connectionPanelContextModel.set({
                    "selectedTab": CP_CONST.TABS.CHAT,
                    "isOpen": true
                });
                LEConnection.vent.trigger("Chat:requested", {
                    group: data.group,
                    referrerAction: CP_CONST.REFERER_ACTION.CLICK_TO_CHAT
                });
            },

            _setContextModelListeners: function () {
                this.listenTo(this.connectionPanelContextModel, "change:isOpen", this._onCPStatusChange);
                this.listenTo(this.connectionPanelContextModel, "change:selectedTab", function (model, selectedTab) {
                    this._setStoragePropertyByKey("selectedTab", selectedTab);
                });
            },

            _onCPStatusChange: function (model, isOpen) {
                LE.context.set("LEConnection.isOpened", isOpen);
                this._setStoragePropertyByKey("isOpen", isOpen);
            },

            _onSoundStateChange: function (soundModel) {
                var soundEnabled = soundModel.get("enabled");

                if (this.connectionPanelContextModel.get("isSoundEnabled") !== soundEnabled) {
                    this.connectionPanelContextModel.set("isSoundEnabled", soundEnabled);
                }
            },
            _setStoragePropertyByKey: function (key, val) {
                val = (typeof val === "string") ? val : JSON.stringify(val);
                Storage.set(this.LOCAL_STORAGE_PREFIX + key, val);
            },
            _getStoragePropertyByKey: function (key) {
                return Storage.get(this.LOCAL_STORAGE_PREFIX + key);
            },
            _cleanLocalStorage: function () {
                this._setStoragePropertyByKey("selectedTab", null);
                this._setStoragePropertyByKey("isOpen", null);
                this._setStoragePropertyByKey("slug", null);
            },
            _showArticleOldCP: function (options) {
                options = options || {};
                if (options.fragment) {
                    this._showArticle(options.fragment);
                }
            },
            _handleLocalStorage: function () {
                if (LE.sessionManager.isExternal()) {
                    this._cleanLocalStorage();
                } else {
                    var logOutTime = this._getStoragePropertyByKey("logOutTime");
                    if (_.isNumber(logOutTime)) {
                        var now = (new Date()).getTime();
                        if ((now - logOutTime) > 60000) {
                            this._cleanLocalStorage();
                        }
                    }
                }
            },
            _isAutoOpenCP: function () {
                if (!LEConfig.connectionPanelAutoStart) {
                    return false;
                }
                if (!LE.sessionManager.isAuthenticated() && this._getStoragePropertyByKey("isOpen") !== "true") {
                    return false;
                }
                if (LE.isFirstTimeLogin()) {
                    return false;
                }
                if (!LE.sessionManager.hasLiveEngage2Feature() && LE.sessionManager.hasMigratingFeature()) {
                    return false;
                }
                if (this._getStoragePropertyByKey("isOpen") === "false") {
                    return false;
                }
                return true;
            },
            _getRouteBuyFixedRout: function (fixedRoute) {
                var tempArr = fixedRoute.split("!");
                var rout = tempArr[1] || tempArr[0];
                return rout;
            },
            _setContextFromExternal: function (data) {

                if (!_.isEmpty(data.area)) {

                    this.connectionPanelContextModel.set("context.page", data.page || null, {silent: true});
                    this.connectionPanelContextModel.set("context.area", data.area);
                }
            },
            _isPermissionGroupAgent:function(){
                var permissionGroup = LE.sessionManager.getPermissionGroupByPrivilege();
                return permissionGroup === CONST.PERMISSION_GROUP.AGENT;
            }
        });
    });

    return LiveEngageManager;
});

